import React from 'react';
import Header from './Header';
import Banner from './Banner';
import Visi from './Visi';
import Misi from './Misi';
import Brand from './Brand';
import Contact from './Contact';
import Footer from './Footer';

export const Portofolio = () => {
  return (
    <div>
        <Header />
        <Banner />
        <Visi />
        <Misi />
        <Brand />
        <Contact />
        <Footer />
    </div>
  )
}
